import { API } from "aws-amplify";
import './init-api';
import { JoinTeacherTribeFormModel, PreLaunchPromoFormModel } from '@model/dist/esm';

const apiName = 'ClientRestApi'
const propertiesPath = '/properties'

export interface InterestsSchema {
    list_id: string;
    categories: {
        list_id: string;
        id: string;
        title: string;
        display_order: number;
        type: 'checkboxes' | 'dropdown' | 'radio' | 'hidden';
        interests?: {
            category_id: string;
            list_id: string;
            id: string;
            name: string;
            display_order: number;
        }[]
    }[]
    total_items: number;
}
export const getInterestsSchema = async (): Promise<InterestsSchema> => {
    return API.get(apiName, `${propertiesPath}/interests-schema`, {})
}

export interface MarketingSchema {
    marketing_permission_id: string;
    text: string;
}
export const getMarketingPermissions = async (): Promise<MarketingSchema[]> => {
    return API.get(apiName, `${propertiesPath}/marketing-permissions`, {})
}


export interface MergeFieldSchema {
    list_id: string;
    merge_fields: MergeField[];
    total_items: number;
}
export interface MergeField {
    merge_id: number;
    default_value: string;
    display_order: number;
    help_text: string;
    list_id: string;
    name: string;
    options?: { choices?: string[] };
    public: boolean;
    required: boolean;
    tag: string;
    type: 'dropdown' | 'address' | 'text' | 'birthday';
}

export const getMergeFields = async (): Promise<MergeFieldSchema> => {
    return API.get(apiName, `${propertiesPath}/merge-fields`, {})
}

export const postJoinTeacherTribe = async (form: JoinTeacherTribeFormModel, captcha: string) => {

    const init = {
        body: {
            form,
            captcha
        }
    }

    return API.post(apiName, `/join-teacher-tribe`, init)
}

export const postPreLaunchPromo = async (form: PreLaunchPromoFormModel, captcha: string) => {

    const init = {
        body: {
            form,
            captcha
        }
    }

    return API.post(apiName, `/pre-launch-promo`, init)
}